import { useTenant } from "../contexts/TenantContext";

/**
 * Single source of truth for "which tenant is this page acting on".
 *
 * Rule:
 *  - Global admins drive the active tenant from the header tenant switcher
 *    (TenantContext.activeTenantId). Selecting "Default (All Tenants)" in the
 *    header sets it to null, meaning "no specific tenant" — callers should
 *    clear tenant-scoped data rather than showing a stale tenant.
 *  - Everyone else is scoped to their own tenant (user.tenantId).
 *
 * Returns:
 *  - tenantId: string | null — the effective tenant to read/write (null = none)
 *  - isGlobalAdmin: boolean
 *  - activeTenantId: string | null — raw header selection (for UI state)
 *  - user
 */
export function useActiveTenant() {
  const ctx = useTenant() || {};
  const { user, activeTenantId } = ctx;

  const isGlobalAdmin = !!user?.roles?.includes("GLOBAL_ADMIN");

  const tenantId = isGlobalAdmin
    ? activeTenantId
      ? String(activeTenantId)
      : null
    : user?.tenantId
      ? String(user.tenantId)
      : null;

  return { tenantId, isGlobalAdmin, activeTenantId, user };
}
